export const mockTeacherRegisterFields = [
  {
    name: "firstName",
    type: "text",
    label: "First Name",
    gridColumn: "span 2",
  },
  { name: "lastName", type: "text", label: "Last Name", gridColumn: "span 2" },
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  { name: "password", type: "password", label: "Password", gridColumn: "span 4" },
  {
    name: "phoneNumber",
    type: "text",
    label: "Phone Number",
    gridColumn: "span 2",
  },
  { name: "qualification", type: "string", label: "Qualification", gridColumn: "span 2" },
  { name: "cnic", type: "number", label: "CNIC", gridColumn: "span 4" },
  {
    name: "profilePicture",
    type: "file",
    label: "Profile Picture",
    gridColumn: "span 4",
  },
];

export const mockTeacherLoginFields = [
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  {
    name: "password",
    type: "password",
    label: "Password",
    gridColumn: "span 4",
  },
];
